import { removeNonNumbers } from 'utils/helpers'

/**
 * Checks if the companyNumber is valid by checking the control digit
 *
 * @param {string} companyNumber
 * @returns {boolean}
 */
export const checkControlDigit = (companyNumber: string): boolean => {
  companyNumber = removeNonNumbers(companyNumber)

  const firstEightNumbers = parseInt(companyNumber.substring(0, 8), 10)
  const rest = firstEightNumbers % 97
  const controlDigit = 97 - rest
  const lastTwoNumbers = parseInt(companyNumber.substring(8), 10)

  return controlDigit === lastTwoNumbers
}
